import {useMessages} from "i18n";
import {ContentSurface, Prose} from "components/ContentPage";

/**
 * The /about page (ui#97, wave 2; localised in ui#101). A real in-flow page — an `<h1>` and crawlable
 * prose on how Transferify works, its encryption model and the company behind it, cross-linking the
 * features, pricing and legal pages. The body copy lives in the active locale catalog
 * (`messages.about`, defined in `src/i18n/richText.*.tsx`) so the page reads in the page's language.
 *
 * Dumb view — no state, no browser APIs, SSG-safe.
 */
export function AboutPageRoot() {
	const {resourceTitles} = useMessages();
	return (
		<ContentSurface>
			<Prose>
				<h1>{resourceTitles.about}</h1>
				<AboutBody/>
			</Prose>
		</ContentSurface>
	);
}

/** Route-neutral About copy shared by the in-flow page and the Resources dialog. */
export function AboutBody() {
	return useMessages().about();
}
